/**
 * Filter Cognito Based Exceptions
 * @param resp
 */
const filterMessage = (resp) => {
  let filteredMessage;

  switch (resp?.code || resp?.__type || resp?.message) {
    case 'UserNotConfirmedException':
      filteredMessage = 'cognitoErrorMessages.userNotConfirmedException';
      break;
    case 'PasswordResetRequiredException':
      filteredMessage = 'cognitoErrorMessages.passwordResetRequiredException';
      break;
    case 'UserLambdaValidationException':
      filteredMessage = 'cognitoErrorMessages.userLambdaValidationException';
      break;
    case 'UserNotFoundException':
      filteredMessage = 'cognitoErrorMessages.userNotFoundException';
      break;
    case 'NotAuthorizedException':
      filteredMessage = 'cognitoErrorMessages.notAuthorizedException';
      break;
    case 'EnableSoftwareTokenMFAException':
      filteredMessage = 'cognitoErrorMessages.oneTimePasswordMismatch';
      break;
    case 'InvalidParameterException':
      filteredMessage = 'cognitoErrorMessages.oneOrMoreFieldsInvalid';
      break;
    case 'UsernameExistsException':
      filteredMessage = 'cognitoErrorMessages.emailAlreadyExists';
      break;
    case 'CodeMismatchException':
      filteredMessage = 'cognitoErrorMessages.oneTimePasswordMismatch';
      break;
    case 'Pending sign-in attempt already in progress':
      filteredMessage = 'cognitoErrorMessages.signInAlreadyInProgress';
      break;
    case 'The quota has been exceeded':
      filteredMessage = 'cognitoErrorMessages.quotaExceededError';
      break;
    default:
      filteredMessage = { errorMsgFromService: resp?.message };
  }

  return filteredMessage;
};

export default filterMessage;
